module.exports = __webpack_public_path__ + "assets/img/main-type-4.4dc3227c.svg";